var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"disabled":_vm.disabled || _vm.loading}},'v-btn',_vm.$attrs,false),[(_vm.loading)?_c('v-progress-circular',{staticClass:"mr-2",attrs:{"color":"primary","width":"3","size":"20","indeterminate":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }